<template>
  <v-card
    loader-height="8"
    :disabled="admin.productsLoading"
    :loading="admin.productsLoading"
    :min-height="minCardHeight"
    rounded
    min-width="400"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      Products
      <v-spacer></v-spacer>
      <v-text-field
        color="black"
        v-model="searchModel"
        clearable
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        rounded
        outlined
        dense
        class="py-1 px-5"
      ></v-text-field>
      <v-icon>{{ app.productIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="productListHeaders"
        :items="admin.productList"
        :items-per-page="15"
        :search="searchModel"
      >
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
        <template v-slot:item.productTypeId="{ item }">
          {{ getProductTypeName(item.productTypeId) }}
        </template>
        <template v-slot:item.sellPrice="{ item }">
          ${{ formatPrice(item.sellPrice) }}
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProduct"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    data() {
      return {
        searchModel: null,
        productListHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'NAME', value: 'name' },
          { text: 'DESC', value: 'description' },
          { text: 'SKU', value: 'sku' },
          { text: 'PRODUCT TYPE', value: 'productTypeId' },
          { text: 'SELL PRICE', value: 'sellPrice', align: 'right' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProductSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProductSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getProductList');
        }
      }
    },
    methods: {
      /**
       * Creates a new Product
       */
      addNewProduct() {
        this.$store.commit('admin/setSelectedProduct', {
          id: 'new',
          sku: '',
          name: '',
          description: '',
          productTypeId: '',
          published: false,
          sellPrice: null
        });
        // auto tab switch
        this.$store.commit(
          'admin/setCurrentProductTab',
          this.admin.PRODUCT_TABS.EDIT
        );
        // clear selection models
        this.clearChildSelectionModels();
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) this.selectProduct(data.item);
        else this.unselectProduct();
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProductSelectionModel',
          value: null
        });
      }
    }
  };
</script>
